import { Control } from "react-hook-form";

import { TextInput } from "components/shared";
import { inputNome } from "_constants";

export const FormChangeTitleAnswer = ({
  control,
}: {
  control: Control<any>;
}) => {
  return (
    <div className="flex-column">
      <div className="width-100 margin-bottom-16">
        <TextInput
          control={control}
          name="title"
          placeholder={inputNome}
          maxLength={75}
          onlyLetters={false}
        />
      </div>
    </div>
  );
};
